const SystemManagementEndpoint = {
  LIST_SYSTEMS: '/cmms/system-management/list-systems',
  ACTIVATE: '/cmms/system-management/activate',
  DEACTIVATE: '/cmms/system-management/deactivate',
  ACTIVATE_AUTO_ACTIVATION: '/cmms/system-management/activate-auto-activation',
  DEACTIVATE_AUTO_ACTIVATION: '/cmms/system-management/deactivate-auto-activation',
  AUTO_ACTIVATION: '/cmms/system-management/get-auto-activation',
  GET_TEST_PARTNER: '/cmms/system-management/get-test-partner',
};

export default SystemManagementEndpoint;
